var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1605",
    "data-name": "Grupo 1605",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.257,
    height: 36.257,
    viewBox: "0 0 36.257 36.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7256",
    "data-name": "Trazado 7256",
    d: "M41.717,528.341a18.129,18.129,0,1,1-18.129-18.129,18.129,18.129,0,0,1,18.129,18.129",
    transform: "translate(-5.46 -510.212)",
    fill: "#5a99ec",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7257",
    "data-name": "Trazado 7257",
    d: "M39.225,564.656a13.6,13.6,0,0,0,13.7-13.7q0-.313-.014-.622a9.8,9.8,0,0,0,2.4-2.492,9.6,9.6,0,0,1-2.764.758,4.83,4.83,0,0,0,2.117-2.663,9.649,9.649,0,0,1-3.057,1.169,4.818,4.818,0,0,0-8.2,4.39,13.666,13.666,0,0,1-9.922-5.029,4.817,4.817,0,0,0,1.49,6.426,4.781,4.781,0,0,1-2.18-.6c0,.02,0,.04,0,.062a4.816,4.816,0,0,0,3.862,4.719,4.811,4.811,0,0,1-2.174.083,4.819,4.819,0,0,0,4.5,3.343,9.658,9.658,0,0,1-5.979,2.061,9.778,9.778,0,0,1-1.148-.067,13.627,13.627,0,0,0,7.379,2.162",
    transform: "translate(-24.759 -536.086)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterColor);
export default __webpack_public_path__ + "static/media/twitter_color.2a51cba6b0cff3db14d1157fcaae73d6.svg";
export { ForwardRef as ReactComponent };